import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import InvoiceWithToken from 'components/public/InvoiceWithToken/InvoiceWithToken';

const InstantAuth = withLazyFallback(
  () => import('components/InstantActions/components/InstantAuth')
);
const InstantPacket = withLazyFallback(
  () => import('components/InstantActions/components/InstantPacket')
);
const InstantActionPage = withLazyFallback(() => import('components/InstantActions/wrapper'));

const INSTANT = [
  { path: 'ia/:token', element: <InstantActionPage /> },
  { path: 'ia/auth/:token', element: <InstantAuth /> },
  { path: 'invoice/:token', element: <InvoiceWithToken /> },
  { path: 'instant-packet', element: <InstantPacket /> },
  { path: 'instant-packet/:step_id', element: <InstantPacket /> },
  { path: 'instant-packet/:step_id/:substep_id', element: <InstantPacket /> }
];

export default INSTANT;
